import {NavLink} from "react-router-dom";
import classNames from "classnames";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {memo, useMemo, useState} from "react";
import {SVG_ICON} from "../common/svg/svg-icon";
import {CONSTANTS} from "../../constants/constants";
import s from './Footer.module.css';

export const Footer = memo(() => {

  const {ROUTES, NAMESPACES, CONFIG} = CONSTANTS;

  const {APP_NAME, CONNECTION_FOOTER} = CONFIG;
  const {TEL, EMAIL} = CONNECTION_FOOTER;

  const {
    HOME,
    PROFILE,
    CAR,
    TOUR,
    TERMS_AND_CONDITIONS,
    ABOUT_US,
  } = ROUTES;

  const {t} = useTranslation(NAMESPACES.COMMON);
  const isMobile = useSelector(state => state.layout.isMobile);

  const [isShow, setIsShow] = useState(false);

  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className={s.wrapper}>

      <div className={classNames(s.container, 'wrapper')}>
        <div className={s['info-block']}>

          <div className={classNames(s.block, s['one-block'])}>
            <NavLink className={s.title} to={HOME.path}>{APP_NAME}</NavLink>
            {/*<p>{t('footer.companyInfo.address.title')}:&nbsp;&nbsp;<span>{t('footer.companyInfo.address.value')}</span></p>*/}
            {/*<p>{t('footer.companyInfo.managedBy.title')}:&nbsp;&nbsp;<span>{t('footer.companyInfo.managedBy.value')}</span></p>*/}
          </div>

          <div className={classNames(s.block, s["two-block"])}>
            {!isMobile && <h4>{t('footer.services.title')}</h4>}
            {isMobile && (
              <button onClick={() => setIsShow(!isShow)}>
                <h4>{t('footer.services.title')}</h4>
                <span>{SVG_ICON.ARROW('white')}</span>
              </button>
            )}

            {(isMobile ? isShow : true) && (
              <>
                <NavLink to={PROFILE.path}>{t(`footer.services.rentalProperty`)}</NavLink>
                <NavLink to={CAR.path}>{t(`footer.services.rentalCars`)}</NavLink>
                <NavLink to={TOUR.path}>{t(`footer.services.tours`)}</NavLink>
              </>
            )}
          </div>

          <div className={classNames(s.block, s['three-block'])}>
            {!isMobile && <h4>{t('footer.company.title')}</h4>}
            {isMobile && (
              <button onClick={() => setIsShow(!isShow)}>
                <h4>{t('footer.company.title')}</h4>
                <span>{SVG_ICON.ARROW('white')}</span>
              </button>
            )}

            {(isMobile ? isShow : true) && (
              <>
                <a href={'/blog/'}>{t('footer.company.blog')}</a>
                <p>{t('footer.company.facalty')}</p>
                <p>{t('footer.company.options')}</p>
              </>
            )}
          </div>

          <div className={classNames(s.block, s['four-block'])}>
            {!isMobile && <h4>{t(`footer.contactUs.title`)}</h4>}
            {isMobile && (
              <button onClick={() => setIsShow(!isShow)}>
                <h4>{t(`footer.contactUs.title`)}</h4>
                <span>{SVG_ICON.ARROW('white')}</span>
              </button>
            )}
            {(isMobile ? isShow : true) && (
              <>
                <a href={`tel:${TEL}`}>{TEL}</a>
                <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
              </>
            )}
          </div>

          <div className={classNames(s.block, s['five-block'])}>
            <div className={s['icons-block']}>
              <a
                href="https://www.instagram.com/rentvipdubai/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >{SVG_ICON.INSTAGRAM('black')}</a>
              <a
                href="https://www.tiktok.com/@rentvipofficial"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >{SVG_ICON.TIKTOK('black')}</a>
              <a
                href="https://www.facebook.com/RentVIPofficial"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >{SVG_ICON.FACEBOOK('black')}</a>
            </div>
          </div>

        </div>

        <div className={s.long}/>

        <div className={s['bottom-block']}>
          <NavLink to={TERMS_AND_CONDITIONS.link()}>{t(`footer.options.termsAndConditions`)}</NavLink>
          <NavLink to={ABOUT_US.link()}>{t(`footer.options.aboutUs`)}</NavLink>
          <p className={s.year}>© {APP_NAME} {year}</p>
        </div>
      </div>
    </footer>
  )
});